import { render } from "./OrderButton.vue?vue&type=template&id=48106766&scoped=true"
import script from "./OrderButton.vue?vue&type=script&lang=js"
export * from "./OrderButton.vue?vue&type=script&lang=js"

import "./OrderButton.vue?vue&type=style&index=0&id=48106766&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48106766"]])

export default __exports__